import { Api } from '../api';
import { IListagemCondicionaisRetorno } from 'shared/types';


const getAll = async (org: number): Promise<IListagemCondicionaisRetorno[] | Error> => {
  try {
    const { data, status } = await Api.get(`/Orgs/${org}/CondicionaisRet`);
    if (data) {
      return data;
    }
    if (status === 204){
      return [];
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getByCanalFornecedora = async (org: number, canal: number, fornecedora: number): Promise<IListagemCondicionaisRetorno[] | Error> => {
  try {
    const { data, status } = await Api.get(`/Orgs/${org}/Canais/${canal}/Fornecedores/${fornecedora}/CondicionaisRet`);
    if (data) {
      return data;
    }
    if (status === 204){
      return [];
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};


export const CondicionaisRetornoService = {
  getAll,
  getByCanalFornecedora,
};
